<template>
  <div>
    <div class="etx-container Container pv-0 bg-secondary HeroVideo fullheight">

      <div class="etx-background-media BackgroundMedia">

        <div class="etx-media Media">

          <video preload="none" autoplay="" muted="" loop="" playsinline="" :poster="image?.sourceUrl?.path">
            <source :src="video?.url?.path" type="video/mp4">
          </video>

        </div>

      </div>

      <div class="BackgroundOverlay">

        <div class="BackgroundOverlay__inner">

          <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1398.4485119 1342.8652894" preserveAspectRatio="none">
            <path class="primary" d="M1133.8537236,972.5138085c-169.7278452-69.8673237-493.066007-202.9924533-691.3511327-544.5406949-15.7085772-27.0442254-108.223833-192.3481558-148.7855591-427.9731136H88.0418375c-33.8458779,432.0166107,248.89133,771.5759962,282.3463497,810.4420605,280.1896355,325.1399005,688.1923882,440.1795262,902.2868973,500.5640784,43.7248292,12.3565322,85.7871934,22.8472638,125.7734274,31.7830264v-287.7756398c-71.8048897-15.5936815-163.1047448-40.703179-264.5947883-82.499717Z"/>
            <path class="secondary" d="M1398.4485119,1342.7891653c-39.986234-8.9357626-82.0485981-19.4264942-125.7734274-31.7830264-214.0945091-60.3845522-622.0972618-175.4241779-902.2868973-500.5640784C336.9331675,771.5759962,54.1959596,432.0166107,88.0418375,0H0v1342.8678742l1398.4485119-.0025848v-.154833.0787089Z"/>
          </svg>

        </div>

      </div>

      <div class="HeroVideo__scrolldown">

        <a href="#start" class="LinkAnchor">
          <span>{{ $texts('label_scroll_down', 'Scroll down') }}</span>
          <img src="~/assets/symbols/vector_scrolldown_herovideo.svg">
        </a>

      </div>

    </div>

    <div class="AnchorPoint" id="start" data-anchor-name="start" data-anchor-offset="true"></div>
  </div>

</template>

<script lang="ts" setup>
const props = defineProps<{
  isEditing?: boolean
  video: {
    url: {
      path: string
    }
  }
  image: {
    sourceUrl: {
      path: string
    }
    alt: {
      alt: string
    }
    title: string
  }
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'hero_home',
  editor: {
    maxInstances: 1,
  }
})

const { $texts } = useNuxtApp()

</script>
